<script>
import { language } from './stores.js';
import { isMobile } from './stores.js';
let isItInMobile;
isMobile.subscribe(value => {
		isItInMobile = value;
	});
</script>

<div id="home-body" class:mobitext="{isItInMobile === true}">
{#if $language == 0}

<p style="text-align: center;">
Mejla oss på <a href="mailto:snaps@fyring.se">snaps@fyring.se</a>
<br> eller ring oss på +46708-261474

</p>

<br>
<hr style="width:75%;text-align:center;opacity:50%">
<br>

<em>
<p style="text-align: center;">
Mail us at <a href="mailto:snaps@fyring.se">snaps@fyring.se</a>
<br> or call us on +46708-261474
</p>
</em>
{:else if $language == 1}
	<p>
	Mejla oss på <a href="mailto:snaps@fyring.se">snaps@fyring.se</a>
</p>
{:else}
<p>
Mail us at <a href="mailto:snaps@fyring.se">snaps@fyring.se</a>
</p>

{/if}
</div>
<style>
	#home-body{
		width:100%;
		text-align: center;
		margin-top: 200px;
	}
	.mobitext{
		margin-top:200px;
	}

	p{
		text-align: left;
		font-size: 16px;
		margin: 50px 10% 50px 10%;
	}
</style>
